import { TranscriptAssessment } from '../models/wellsharp/assessments';
import { publicApiRequest } from '../utils/axios';

export async function fetchWellsharpData(email: string): Promise<TranscriptAssessment[]> {
  return publicApiRequest('GET', `/misc/assessments?email=${email}`);
}
